export default __webpack_public_path__ + "static/graph-428cc7438c46e7f4457beab0eaed1543.png";